import { observer } from 'mobx-react';
import { useState } from 'react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from 'src/constants/styles';
import Icon from 'src/view/components/Controls/Icon/Icon';
import SearchInput from 'src/view/components/Controls/SearchInput/SearchInput';
import { TabLabel } from 'src/view/components/Controls/TabLabel/TabLabel';
import { useLiveOrdersContext } from '~/mobx/ordersStore/context';
import { LiveOrdersTab } from '~/mobx/ordersStore/liveOrdersStore';
import { OrderTabs } from '~/mobx/ordersStore/types';
import { history } from '~/services/history';
import { LoadingStatus } from '~/types/main';
import getOrdersPath from '~/view/screens/CheckoutScreen/getOrdersPath';

const OrdersStatuses = () => {
  const { store: liveOrdersStore } = useLiveOrdersContext();
  const [searchMode, setSearchMode] = useState(false);

  const onTabPress = (tab: any) => {
    liveOrdersStore.setActiveTab(tab as LiveOrdersTab);
    history.push(getOrdersPath(liveOrdersStore));
  };

  const onBlur = () => {
    if (!liveOrdersStore.searchValue) {
      setSearchMode(false);
    }
  };

  const onReset = () => {
    liveOrdersStore.resetSearch();
    onBlur();
  };

  const onSearch = (value: string) => {
    liveOrdersStore.changeSearch(value);
  };

  return (
    <div className="d-flex flex-row align-items-center">
      <div className="pr-2">
        {searchMode || liveOrdersStore.searchValue ? (
          <SearchInput
            value={liveOrdersStore.searchValue}
            onChangeText={onSearch}
            onReset={onReset}
            onBlur={onBlur}
            loading={liveOrdersStore.ordersLoadingStatus === LoadingStatus.Loading}
            placeholder="search_all_orders"
            withResetIcon
            autoFocus
            className="callcenter-tabs__search-input"
            inputClassName="bg-graysoft color-dark text-size-16 family-medium"
            customPlaceholderTextClassName="color-graysection"
          />
        ) : (
          <Icon
            name={Icons.Search}
            color={theme.colors.dark}
            className="callcenter-tabs__search-icon tab-label mr-2"
            onPress={() => setSearchMode(true)}
          />
        )}
      </div>
      {liveOrdersStore.tabs.map(([tabKey, tab]) => (
        <TabLabel
          key={tabKey}
          value={tabKey}
          label={tab.label}
          onPress={onTabPress}
          count={tab.newOrders?.size || 0}
          isActive={liveOrdersStore.activeTabKey === tabKey && !searchMode && !liveOrdersStore.searchValue}
          color={tabKey === OrderTabs.ActionRequired ? 'red' : 'blue'}
        />
      ))}
    </div>
  );
};

export default observer(OrdersStatuses);
